/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartComboGroupRequestSchema } from "./banquetCartComboGroupRequestSchema.ts";

export const banquetCartComboRequestSchema = z.object({
	id: z.uuid(),
	amount: z.int(),
	groups: z.array(banquetCartComboGroupRequestSchema),
});
